import React from 'react';
import { observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import { Card, Avatar, List, Form, Input, Button, Spin } from 'antd';
import moment from 'moment';

import { ShippingItemStoreContext } from './AppContexts';

@observer
class PrintShippingItems extends React.Component {
	static contextType = ShippingItemStoreContext;

	state = {
	};

	print = () => {
		window.print();
	}

	render() {
		if (this.context.printableItems.length == 0){
			return <Redirect to='/' />
		}
		let items = this.context.printableItems;
		return (<>
		<div className="screen">
		  <Button type="primary" onClick={this.print} style={{marginTop: 30}}
			  icon="printer"
			  >STAMPA</Button>
		  { items.map( (item, index) => (
		  <div key={index} style={{ padding: "10px 0" }}><strong>Bolla: {item.deliveryNoteId} - Data: { moment(item.deliveryNoteDate).format('YYYY-MM-DD') }</strong>
		      <br/> Collo {item.packageSeq} di {item.packagesTot} pronto per la stampa...
		  </div>
		  ) ) }
		</div>
		<div className="print">
		  { items.map( (item, index) => (
		  <page pagesize="A4" key={index}>
		    <div className="halfpage">
		      <div className="left">
			<div className="intestazione">
			  <div className="logo"><img src="/download/img/eno-r.svg" /></div>
			  <div className="intest">
			    <h1>Enoteca Ricciardi</h1>
			    <p>Piazza Vesuvio 11 - 20144 MIlano<br/>
			      tel. 02 8940 2627<br/>
			      www.enoteca-ricciardi.it</p>
			  </div>
			  <div className="clearfix"></div>
			</div>
			<div className="cliente">
			  cliente<br/>
			  <span>{item.client}</span>
			</div>
			<div className="bollacollo">
			  <div className="sx">
			    <div className="numbol">
			      bolla n° <span className="nb">{item.deliveryNoteId}</span>
			      <span className="anno">/{moment(item.deliveryNoteDate).format('YY')}</span>
			    </div>
			  </div>
			  <div className="dx">
			    <div className="collo">
			      collo<span className="nc">{item.packageSeq}</span> di<span className="nc">{item.packagesTot}</span>
			    </div>
			  </div>
			  <div className="clearfix"></div>
			</div>
			<div className="datachili">
			  <div className="sx">
			    data <span className="data">{ moment(item.deliveryNoteDate).format('DD/MM/YYYY')}</span>
			  </div>
			  <div className="dx">
			    peso kg <span className="kg">{item.grossWeight}</span>
			  </div>
			  <div className="clearfix"></div>
			</div>
			<div className="descrizione">
			  descrizione<br/>
			  <span>{item.description}</span>
			</div>
			<div className="destinatario">
			  <div>
			    destinatario<br/>
			    <span>{ item.recipient }</span>
			  </div>
			  { item.attention &&
			  <div>
			    all'attenzione di<br/>
			    <span>{ item.attention }</span>
			  </div> }
			  <div>
			    indirizzo di consegna<br/>
			    <span>{ item.address }</span><br/>
			    <span>{ item.zip } { item.city }{ item.provinceIT ? ` (${item.provinceIT})` : '' } - { item.country }</span>
			  </div>
			  { item.phone ? (
			  <div>
			    telefono<br/>
			    <span>{ item.phone }</span>
			  </div>) : null }
			</div>
		      </div>
		      <div className="right">
			<div className="note">
			  note di consegna<br/>
			  <p>{item.notes ? <strong>{item.notes}</strong> : null }</p>
			  <hr/>
			  <hr/>
			  <hr/>
			  <hr/>
			  <hr/>
			</div>
			<div className="firma">
			  <img src="/download/img/firma.svg" /> <strong>firma per accettazione</strong> 
			</div>
			<div className="disclaimer">beni esenti dall'obbligo di emissione di bolla di accompagnamento a norma dell'art.4 n°8 del DPR 627 del 06/10/1978</div>
		      </div>
		    </div>
		    <div className="halfpage second">
		      <div className="left">
			<div className="intestazione">
			  <div className="logo"><img src="/download/img/eno-r.svg" /></div>
			  <div className="intest">
			    <h1>Enoteca Ricciardi</h1>
			    <p>Piazza Vesuvio 11 - 20144 MIlano<br/>
			      tel. 02 8940 2627<br/>
			      www.enoteca-ricciardi.it</p>
			  </div>
			  <div className="clearfix"></div>
			</div>
			<div className="cliente">
			  cliente<br/>
			  <span>{ item.client }</span>
			</div>
			<div className="bollacollo">
			  <div className="sx">
			    <div className="numbol">
			      bolla n° <span className="nb">{ item.deliveryNoteId }</span>
			      <span className="anno">/{ moment(item.deliveryNoteDate).format('YY') }</span>
			    </div>
			  </div>
			  <div className="dx">
			    <div className="collo">
			      collo<span className="nc">{ item.packageSeq }</span> di<span className="nc">{ item.packagesTot }</span>
			    </div>
			  </div>
			  <div className="clearfix"></div>
			</div>
			<div className="datachili">
			  <div className="sx">
			    data <span className="data">{ moment(item.deliveryNoteDate).format('DD/MM/YYYY') }</span>
			  </div>
			  <div className="dx">
			    peso kg <span className="kg">{ item.grossWeight }</span>
			  </div>
			  <div className="clearfix"></div>
			</div>
			<div className="descrizione">
			  descrizione<br/>
			  <span>{ item.description }</span>
			</div>
			<div className="destinatario">
			  <div>
			    destinatario<br/>
			    <span>{ item.recipient }</span>
			  </div>
			  { item.attention &&
			  <div>
			    all'attenzione di<br/>
			    <span>{ item.attention }</span>
			  </div> }
			  <div>
			    indirizzo di consegna<br/>
			    <span>{ item.address }</span><br/>
			    <span>{ item.zip } { item.city }{ item.provinceIT ? ` (${item.provinceIT})` : '' } - { item.country }</span>
			  </div>
			  { item.phone ? (
			  <div>
			    telefono<br/>
			    <span>{ item.phone }</span>
			  </div>) : null }
			</div>
		      </div>
		      <div className="right">
			<div className="note">
			  note di consegna<br/>
			  <p>{item.notes ? <strong>{item.notes}</strong> : null }</p>
			  <hr/>
			  <hr/>
			  <hr/>
			  <hr/>
			  <hr/>
			</div>
			<div className="firma">
			 <img src="/download/img/firma.svg" /> <strong>firma per accettazione</strong> 
			</div>
			<div className="disclaimer">beni esenti dall'obbligo di emissione di bolla di accompagnamento a norma dell'art.4 n°8 del DPR 627 del 06/10/1978</div>
		      </div>
		    </div>
		  </page>
		  ) ) }
		</div> 
		</>);
	}
}

export {
	PrintShippingItems
}
